import './style.scss';
import React from 'react';
import classnames from 'classnames';

export default function ProgressBar({ percentage, color, className }) {
  let style = { width: `${percentage}%` };
  if (color) style.backgroundColor = color;
  if (percentage > 0) style.minWidth = '1rem';

  return (
    <div className={classnames('progress-bar', className)}>
      <div className="progress-bar__bar" style={style} />
    </div>
  );
}
